import { getAccessToken } from '@libs/focus-frontend-services/src/AuthenticationService';
import API, { camelCase, snakeCase } from '@teamleader/api';

const VERSION = '2023-10-01';

export const plainApi = API({
  getAccessToken,
  baseUrl: `${environment.API_URL}`,
  version: VERSION,
});

export const api = API({
  getAccessToken,
  baseUrl: `${environment.API_URL}`,
  version: VERSION,
  plugins: {
    request: [snakeCase],
    response: [camelCase],
  },
});

export const uploadFileAsStream = async (location: string, file: File, signal: AbortSignal) => {
  const response = await fetch(location, {
    headers: {
      'Content-Type': 'application/octet-stream',
      Authorization: `Bearer ${await getAccessToken()}`,
      'X-Api-Version': VERSION,
    },
    method: 'POST',
    body: file,
    signal,
  });

  return await response.json();
};

export const uploadFileAsMultipartFormData = async (location: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(location, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
      'X-Api-Version': VERSION,
    },
    method: 'POST',
    body: formData,
  });

  return await response.json();
};
